// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".toggle-sidebar[data-v-028fa632] {\n  margin-left: var(--space-minus-small);\n}", "",{"version":3,"sources":["/app/app/javascript/dashboard/components/SidemenuIcon.vue"],"names":[],"mappings":"AAuBA;EACE,qCAAA;AAtBF","file":"SidemenuIcon.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.toggle-sidebar {\n  margin-left: var(--space-minus-small);\n}\n"]}]);
// Exports
module.exports = exports;
